// extracted by mini-css-extract-plugin
export var breadcrumb = "breadcrumb-module--breadcrumb--a05f8";
export var breadcrumbContainer = "breadcrumb-module--breadcrumbContainer--19e9a";
export var home = "breadcrumb-module--home--2f79d";
export var lastPage = "breadcrumb-module--lastPage--dd27b";
export var pElement = "breadcrumb-module--pElement--155b5";